// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__+NNre","heading":"AboutUs_heading__mvZbH","iframe":"AboutUs_iframe__kIW9a","rightContent":"AboutUs_rightContent__46aZp"};